import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import FileUploader from '../FileUploader.js/FileUploader';
import InfoHubCategoryDropdown from '../InfoHubCategoryDropdown/InfoHubCategoryDropdown';
import EmployeeVisibilityDropdown from '../VisibilityDropdown/EmployeeVisibilityDropdown';
import EntityVisibilityDropdown from '../VisibilityDropdown/EntityVisibilityDropdown';
import { EntityList } from '../VisibilityDropdown/EntityList';

const AddFileModal = ({ handleClose, show, onAdd }) => {
    const [categoryID, setCategoryID] = useState('');
    const [fileName, setFileName] = useState('');
    const [fileLink, setFileLink] = useState('');
    const [fileType, setFileType] = useState('');
    const [fileSize, setFileSize] = useState('');
    const [employee, setEmployee] = useState('');
    const [createdBy, setCreatedBy] = useState('');

    const [selectedEntity, setSelectedEntity] = useState([]);

    const options = EntityList;

    useEffect(() => {
        setCreatedBy(localStorage.getItem('badgeID'));
    }, []);

    const getCategoryID = (categoryIDProp) => {
        setCategoryID(categoryIDProp);
    };

    const getEmployeeVisibility = (employeeVisibilityProp) => {
        let newEmployee = employeeVisibilityProp.toString();
        setEmployee(newEmployee);
    };

    const getFileInfo = (
        fileNameProp,
        fileLinkProp,
        fileTypeProp,
        fileSizeProp
    ) => {
        setFileName(fileNameProp);
        setFileLink(fileLinkProp);
        setFileType(fileTypeProp);
        setFileSize(fileSizeProp);
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if (!categoryID) {
            alert('Please select a category name');
        } else if (!fileName || !fileLink || !fileSize) {
            alert('Please upload a file first');
        } else if (!employee) {
            alert('Please select an employee type');
        } else if (selectedEntity.length === 0) {
            alert('Please select an entity type');
        } else {
            const entity = selectedEntity.map((x) => x.value).toString();

            onAdd({
                categoryID,
                fileName,
                fileLink,
                fileType,
                fileSize,
                employee,
                entity,
                createdBy,
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Upload New File
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Form.Group className='mb-3'>
                        <Form.Label>Folder Name</Form.Label>
                        <InfoHubCategoryDropdown
                            getCategoryID={getCategoryID}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Upload File</Form.Label>
                        <FileUploader getFileInfo={getFileInfo} />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Visible To</Form.Label>
                        <EmployeeVisibilityDropdown
                            getEmployeeVisibility={getEmployeeVisibility}
                        />
                        <EntityVisibilityDropdown
                            options={options}
                            value={selectedEntity}
                            onChange={setSelectedEntity}
                        />
                    </Form.Group>
                    <Button as='input' type='submit' value='Submit' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddFileModal;
